<template>
  <form id="ip-legal-form" @submit.prevent>

    <radio-box :question="getQuestionByTag('Q60')"
               @onAnswer="onQ60Answer"
               v-model="formData['Q60']"></radio-box>

    <div v-if="getAnswerTitle('Q60') === 'Yes'">
      <div class="field">
        <label class="label">
          {{ getQuestionByTag('Q61').title }}
          <b-tooltip :label="getQuestionByTag('Q61').desc"
                     v-if="getQuestionByTag('Q61').desc !== ''"
                     type="is-light"
                     position="is-right" size="is-large" multilined>
            <div class="tooltip-icon">!</div>
          </b-tooltip>
        </label>
        <div class="sep-16"></div>
        <div class="control">
          <falcon-select :options="countries" vrules="required" vtarget="input[type=hidden]"
                         label="name" v-model="formData['incorporation_country_id']"
                         @onSelect="onIncorporationLocation"></falcon-select>
        </div>
        <div class="help is-danger vrule" rule="required">
          This field is required.
        </div>
      </div>

      <!-- city or state -->
      <div class="control" v-if="loading">
        Load cities ..
      </div>
      <div class="control field"
           v-if="!isUSSelected && cities.length>0">
        <div>
          <label class="label">
            Incorporation City
          </label>
          <div class="sep-8"></div>
          <falcon-select
              vtarget="input[type=hidden]"
              class="col-md-4"
              label="name" value="id" :options="cities"
              v-model="formData['incorporation_city_id']"></falcon-select>
          <div class="sep-16"></div>
        </div>
        <div class="help is-danger vrule" rule="required">
          This field is required.
        </div>
      </div>
      <div class="control field"
           v-if="isUSSelected">
        <label class="label">
          Incorporation State
        </label>
        <div class="sep-8"></div>
        <falcon-select
            vtarget="input[type=hidden]"
            class="col-md-4"
            label="name" value="id" :options="states"
            v-model="formData['incorporation_state_id']"></falcon-select>
        <div class="help is-danger vrule" rule="required">
          This field is required.
        </div>
        <div class="sep-16"></div>
      </div>
      <!-- //city or state -->


      <radio-box :question="getQuestionByTag('Q62')"
                 v-model="formData['Q62']"></radio-box>
      <radio-box :question="getQuestionByTag('Q63')"
                 v-model="formData['Q63']"></radio-box>
    </div>

    <radio-box :question="getQuestionByTag('Q64')"
               v-model="formData['Q64']" @onAnswer="onQ64Change"></radio-box>

    <radio-box :question="getQuestionByTag('Q65')"
               v-model="formData['Q65']" v-if="getAnswerTitle('Q64') === 'Yes'"></radio-box>

    <radio-box :question="getQuestionByTag('Q66')"
               v-model="formData['Q66']"></radio-box>

  </form>
</template>

<script>
import {FormsMixin} from "@/modules/calculator/forms/FormsMixin";
import RadioBox from "@/modules/calculator/components/RadioBox";
import FalconSelect from "@/shared/forms/FalconSelect";
import FounderDetails from "@/modules/calculator/components/FounderDetails";
import {FormValidation} from "@/shared/directives/formValidation";
import {LookupsAPI} from "@/apis/LookupsAPI";

export default {
  name: "IPLegalForm",
  mixins: [FormsMixin],
  components: {RadioBox, FalconSelect,},
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    formData: Object
  },
  data() {
    return {
      loading: false,
      answers: {},
      cities: [],
      states: [],
      showIfStartupIncorporated: false,
      incorporation_country_id: {},
      countries: [],
      formValidation: null
    }
  },
  async mounted() {
    this.formValidation = new FormValidation('#ip-legal-form');
    this.countries = await LookupsAPI.getCountries();
    // this.cities = await LookupsAPI.getCities(selectedOption.id);

    // for debugging only
    if( this.isUSSelected) {
      this.states = await LookupsAPI.getStates(this.formData.incorporation_country_id.id);
    }
  },
  methods: {
    async onIncorporationLocation(selectedOption) {
      this.loading = true;
      if (selectedOption.id !== 233) {
        this.cities = [];
        this.cities = await LookupsAPI.getCities(selectedOption.id);
      } else if (selectedOption.id) {
        this.states = await LookupsAPI.getStates(selectedOption.id);
      }
      this.loading = false;
      // console.log(selectedOption)
    },
    getData() {
      let data = this.formatAnswers();
      if(data['incorporation_country_id']) {
        data['incorporation_country_id'] = data['incorporation_country_id']['id'];
      }

      if(data['incorporation_city_id']) {
        data['incorporation_city_id'] = data['incorporation_city_id']['id'];
      }

      if(data['incorporation_state_id']) {
        data['incorporation_state_id'] = data['incorporation_state_id']['id'];
      }

      return data;
    },
    onQ60Answer(answer, question){
      if(answer.title !== 'Yes'){
        delete this.formData['incorporation_country_id'];
        delete this.formData['incorporation_state_id'];
        delete this.formData['incorporation_city_id'];
        delete this.formData['Q62'];
        delete this.formData['Q63'];
      }
    },
    onQ64Change(answer, question){
      if(answer.title !== 'Yes'){
         delete this.formData['Q65'];
      }
    }
  },
  computed: {
    isUSSelected() {
      return this.formData['incorporation_country_id'] && this.formData['incorporation_country_id'].id === 233;
    }
  }
}
</script>

<style scoped>

</style>
